<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch" 
      @showType="showType"
      :noResetCall="true"
      :filters="filterConfig"
    />
    <TableView
      :headers="headers"
      :items="merchants"
      :options.sync="options"
      :loading="loading"
      :totalData="totalMerchants"
      :refresh-table="getData"
      :bodyFilter="true"
      item-key="id"
      table-height="70vh"
      :customTopActions="true"
    >     
      <template v-slot:top>
        <div class="d-flex justify-end mb-2">
          <v-btn
            color="warning"
            icon
            @click="getData"
            class="mr-2"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon>mdi-refresh</v-icon>
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>mdi-cached</v-icon>
              </span>
            </template>
          </v-btn>

          <v-menu
            offset-y
            rounded="lg"
            transition="slide-y-transition"
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="warning"
                icon
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon light size="20">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item link @click="exportExcel()">
                <v-list-item-icon>
                  <v-icon>mdi-file-excel</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Export to excel</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>

      <template v-slot:body-prepend>
        <TableFilterTrackingInputer :search.sync="search" :options.sync="options" v-on:getDataParent="getData" />
      </template>
      <template v-slot:action="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
          <v-icon small class="mr-2" @click="viewItem(item)">
            mdi-eye
          </v-icon>
        </td>
      </template>
    </TableView>
  </v-card>
</template>
<script>

import trackingPengajuanInputerMixin from '../../components/merchant-application/inputer-tracking-pengajuan/trackingPengajuanInputerMixin';
import  TableFilterTrackingInputer  from '../../components/merchant-application/inputer-tracking-pengajuan/components';

export default {
  mixins: [trackingPengajuanInputerMixin],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableSearchFilter: () => import("../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    TableFilterTrackingInputer
  }

};
</script>


<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
